import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Info } from 'lucide-react';
import { useUser } from '../../contexts/UserContext';
import {
  fetchActiveSystemNotifications,
  handleSystemNotificationTokenExpired,
} from '../../services/systemNotificationApi';
import './SystemNotificationBanner.css';

// Dashboard 2 shares the notifications configured for the Dashboard screen.
const toNotificationScreen = (pathname) => (pathname === '/dashboard-2' ? '/' : pathname);

export default function SystemNotificationBanner() {
  const { clearUserData } = useUser();
  const location = useLocation();
  const [notifications, setNotifications] = useState([]);
  const token = localStorage.getItem('authToken');

  useEffect(() => {
    if (!token) {
      setNotifications([]);
      return undefined;
    }

    let cancelled = false;
    fetchActiveSystemNotifications({
      token,
      screenPath: toNotificationScreen(location.pathname),
      onTokenExpired: () => handleSystemNotificationTokenExpired(clearUserData),
    }).then((result) => {
      if (cancelled) return;
      setNotifications(result.ok ? result.notifications : []);
    });

    return () => {
      cancelled = true;
    };
  }, [token, location.pathname, clearUserData]);

  if (!notifications.length) return null;

  return (
    <div className="system-notification-stack" role="region" aria-label="System notifications">
      {notifications.map((item) => (
        <div key={item.id} className="system-notification-banner">
          <Info size={18} className="system-notification-icon" aria-hidden />
          <p className="system-notification-text">{item.messageText}</p>
        </div>
      ))}
    </div>
  );
}
